import { takeLatest, put, call } from 'redux-saga/effects';
import * as SettingActions from './actions';
import * as SettingService from '../../../api/SettingService';
import i18n from '../../../i18n/i18n';
import type { Effect } from 'redux-saga/effects';

export function* handleFetchBanner(): Generator<Effect, void, any> {
  try {
    const response = yield call(SettingService.getBanners);
    const {
      data: { banners },
    } = response;
    console.log('handleFetchBanner', response);
    yield put(SettingActions.fetchBannerSuccess(banners));
  } catch (err) {
    const error = err as any;
    const message = error?.response?.data?.error?.message;
    yield put(
      SettingActions.fetchBannerFail(
        message?.[i18n.getLang()] || 'Error occurred fetching banner',
      ),
    );
  }
}

export function* watchFetchBanner() {
  yield takeLatest(SettingActions.FETCH_BANNER, handleFetchBanner);
}
